import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content to prevent XSS attacks.
 * Only allows safe formatting tags.
 */
export const sanitizeHtml = (dirty) => {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    // Allow safe formatting plus anchors (for linkified URLs in bios/DMs).
    // DOMPurify validates href and blocks javascript:/data: schemes; we still
    // force-add rel=noopener and target=_blank via a hook below.
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'br', 'span', 'a'],
    ALLOWED_ATTR: ['href', 'target', 'rel']
  });
};

// Harden every sanitized anchor: open in a new tab and prevent tab-nabbing,
// regardless of what the input markup specified.
if (typeof DOMPurify.addHook === 'function') {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('href')) {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer nofollow');
    }
  });
}
